import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { RentalInformation } from './rentalInformation';
import { Image } from './image';

export class AccessibilityFeature {
    constructor(doc)
    {
		this.label = null;
		this.accessibilityFeatureType = null;
		this.accessibilityFeatureTypeOtherDescription = null;
		this.accessibilityModificationDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.accessibilityFeatureType = x.getStringElement(doc, "./ns:AccessibilityFeatureType");
		this.accessibilityFeatureTypeOtherDescription = x.getStringElement(doc, "./ns:AccessibilityFeatureTypeOtherDescription");
		this.accessibilityModificationDescription = x.getStringElement(doc, "./ns:AccessibilityModificationDescription");
   }

	GetAccessibilityFeatureType() {
		return h.descriptionOrOther(this.accessibilityFeatureType, this.accessibilityFeatureTypeOtherDescription);
	}
}

export class FloorCovering {
    constructor(doc)
    {
		this.label = null;
		this.flooringType = null;
		this.flooringTypeOtherDescription = null;
		this.improvementComponentConditionDescription = null;
		this.improvementComponentConditionStatusType = null;
		this.improvementComponentQualityDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.flooringType = x.getStringElement(doc, "./ns:FlooringType");
		this.flooringTypeOtherDescription = x.getStringElement(doc, "./ns:FlooringTypeOtherDescription");
		this.improvementComponentConditionDescription = x.getStringElement(doc, "./ns:ImprovementComponentConditionDescription");
		this.improvementComponentConditionStatusType = x.getStringElement(doc, "./ns:ImprovementComponentConditionStatusType");
		this.improvementComponentQualityDescription = x.getStringElement(doc, "./ns:ImprovementComponentQualityDescription");
   }
}

export class InteriorComponentDetail {
    constructor(doc)
    {
		this.label = null;
		this.improvementComponentConditionDescription = null;
		this.improvementComponentConditionStatusType = null;
		this.improvementComponentConditionSummaryDescription = null;
		this.improvementComponentQualityDescription = null;
		this.improvementComponentQualitySummaryDescription = null;
		this.improvementComponentType = null;
		this.improvementComponentTypeAdditionalDescription = null;
		this.improvementComponentTypeOtherDescription = null;
		this.overallFlooringUpdateStatusType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.improvementComponentConditionDescription = x.getStringElement(doc, "./ns:ImprovementComponentConditionDescription");
		this.improvementComponentConditionStatusType = x.getStringElement(doc, "./ns:ImprovementComponentConditionStatusType");
		this.improvementComponentConditionSummaryDescription = x.getStringElement(doc, "./ns:ImprovementComponentConditionSummaryDescription");
		this.improvementComponentQualityDescription = x.getStringElement(doc, "./ns:ImprovementComponentQualityDescription");
		this.improvementComponentQualitySummaryDescription = x.getStringElement(doc, "./ns:ImprovementComponentQualitySummaryDescription");
		this.improvementComponentType = x.getStringElement(doc, "./ns:ImprovementComponentType");
		this.improvementComponentTypeAdditionalDescription = x.getStringElement(doc, "./ns:ImprovementComponentTypeAdditionalDescription");
		this.improvementComponentTypeOtherDescription = x.getStringElement(doc, "./ns:ImprovementComponentTypeOtherDescription");
		this.overallFlooringUpdateStatusType = x.getStringElement(doc, "./ns:OverallFlooringUpdateStatusType");
   }
}

export class CeilingHeight {
    constructor(doc)
    {
		this.label = null;
		this.approximateCeilingHeightType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.approximateCeilingHeightType = x.getStringElement(doc, "./ns:ApproximateCeilingHeightType");
   }
}

export class CeilingStyle {
    constructor(doc)
    {
		this.label = null;
		this.ceilingStyleType = null;
		this.ceilingStyleTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.ceilingStyleType = x.getStringElement(doc, "./ns:CeilingStyleType");
		this.ceilingStyleTypeOtherDescription = x.getStringElement(doc, "./ns:CeilingStyleTypeOtherDescription");
   }

	 GetCeilingStyleType() {
		return h.descriptionOrOther(this.ceilingStyleType, this.ceilingStyleTypeOtherDescription);
	 }
}

export class WallsAndCeiling {
    constructor(doc)
    {
		this.label = null;
		this.ceilingHeights = [];
		this.ceilingStyles = [];
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:CEILING_HEIGHTS/ns:CEILING_HEIGHT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.ceilingHeights.push(new CeilingHeight(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:CEILING_STYLES/ns:CEILING_STYLE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.ceilingStyles.push(new CeilingStyle(xn));
			});
		}
   }

	GetDetail() {
	var detail = "";
	for (var height of this.ceilingHeights) 
		detail = h.addWithSpacer(detail, h.toEnumText(height.approximateCeilingHeightType));

	for (var style of this.ceilingStyles) 
		detail = h.addWithSpacer(detail, style.GetCeilingStyleType());

	return detail;
	}

}

export class InteriorComponent {
    constructor(doc)
    {
		this.label = null;
		this.floorCoverings = [];
		this.images = [];
		this.interiorComponentDetail = null;
		this.wallsAndCeiling = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:FLOOR_COVERINGS/ns:FLOOR_COVERING");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.floorCoverings.push(new FloorCovering(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:INTERIOR_COMPONENT_DETAIL");
		if (node !== null)
				this.interiorComponentDetail = new InteriorComponentDetail(node);
		node = x.selectSingleNode(doc, "./ns:WALLS_AND_CEILING");
		if (node !== null)
				this.wallsAndCeiling = new WallsAndCeiling(node);
  }

	GetComponentStatus() {
		return h.descriptionOrOther(this.interiorComponentDetail.improvementComponentConditionStatusType, this.interiorComponentDetail.improvementComponentConditionStatusTypeOtherDescription);
	}
	GetComponentType() {
		return h.descriptionOrOther(this.interiorComponentDetail.improvementComponentType, this.interiorComponentDetail.improvementComponentTypeOtherDescription);
	}

}

export class Level {
    constructor(doc)
    {
		this.label = null;
		this.accessType = null;
		this.belowGradeExteriorAccessType = null;
		this.belowGradeExteriorAccessTypeOtherDescription = null;
		this.gradeLevelType = null;
		this.levelFinishedAreaMeasure = null;
		this.levelUnfinishedAreaMeasure = null;
		this.levelType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.accessType = x.getStringElement(doc, "./ns:AccessType");
		this.belowGradeExteriorAccessType = x.getStringElement(doc, "./ns:BelowGradeExteriorAccessType");
		this.belowGradeExteriorAccessTypeOtherDescription = x.getStringElement(doc, "./ns:BelowGradeExteriorAccessTypeOtherDescription");
		this.gradeLevelType = x.getStringElement(doc, "./ns:GradeLevelType");
		this.levelFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:LevelFinishedAreaMeasure");
		this.levelType = x.getStringElement(doc, "./ns:LevelType");
		this.levelUnfinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:LevelUnfinishedAreaMeasure");
   }

	GetLevelDetail() {
		var detail = "";
		if (this.gradeLevelType.endsWith("BelowGrade"))
			detail = h.addWithNewline(detail, h.toEnumText(this.accessType));
		if (this.accessType.includes("ExteriorAccess"))
			detail = h.addWithNewline(detail, this.GetBelowGradeExteriorAccessType());
		detail = h.addWithNewline(detail, h.toEnumText(this.gradeLevelType));
		return detail;
	}

	GetLevelType() {
		return h.toEnumText(this.levelType);
	}

	GetBelowGradeExteriorAccessType() {
		return h.descriptionOrOther(this.belowGradeExteriorAccessType, this.belowGradeExteriorAccessTypeOtherDescription);
	}

}

export class PropertyUnitArea {
    constructor(doc)
    {
		this.label = null;
		this.allowableWorkSpaceAreaMeasure = null;
		this.unitAboveGradeUnfinishedAreaMeasure = null;
		this.unitBelowGradeUnfinishedAreaMeasure = null;
		this.unitNonStandardAboveGradeFinishedAreaMeasure = null;
		this.unitNonStandardBelowGradeFinishedAreaMeasure = null;
		this.unitStandardAboveGradeFinishedAreaMeasure = null;
		this.unitStandardBelowGradeFinishedAreaMeasure = null;
		this.unitTotalFinishedAreaMeasure = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.allowableWorkSpaceAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:AllowableWorkSpaceAreaMeasure");
		this.unitAboveGradeUnfinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitAboveGradeUnfinishedAreaMeasure");
		this.unitBelowGradeUnfinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitBelowGradeUnfinishedAreaMeasure");
		this.unitNonStandardAboveGradeFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitNonStandardAboveGradeFinishedAreaMeasure");
		this.unitNonStandardBelowGradeFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitNonStandardBelowGradeFinishedAreaMeasure");
		this.unitStandardAboveGradeFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitStandardAboveGradeFinishedAreaMeasure");
		this.unitStandardBelowGradeFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitStandardBelowGradeFinishedAreaMeasure");
		this.unitTotalFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:UnitTotalFinishedAreaMeasure");
   }
}

export class PropertyUnitDetail {
    constructor(doc)
    {
		this.label = null;
		this.accessoryDwellingUnitIndicator = null;
		this.accessoryDwellingUnitLegallyRentableIndicator = null;
		this.accessoryDwellingUnitTypicalToMarketIndicator = null;
		this.accessType = null;
		this.allowableLiveWorkSpaceIndicator = null;
		this.bedroomCount = null;
		this.cornerUnitIndicator = null;
		this.floorIdentifier = null;
		this.fullBathroomCount = null;
		this.gradeLevelType = null;
		this.halfBathroomCount = null;
		this.interiorConditionRatingCode = null;
		this.interiorQualityRatingCode = null;
		this.levelCount = null;
		this.overallBathroomsQualityDescription = null;
		this.overallBathroomsUpdateStatusType = null;
		this.separatePostalAddressIndicator = null;
		this.unitBelowGradeFinishComparisonType = null;
		this.unitIdentifier = null;
		this.unitIncludedInRentScheduleIndicator = null;
		this.unitInteriorDefectsExistIndicator = null;
		this.unitMixedUsageIndicator = null;
		this.unitOccupancyType = null;
		this.unitUtilitiesOperatingIndicator = null;
		this.unitValuationCommentText = null;
		this.utilitiesMeteredSeparatelyIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.accessoryDwellingUnitIndicator = x.getBooleanElement(doc, "./ns:AccessoryDwellingUnitIndicator");
		this.accessoryDwellingUnitLegallyRentableIndicator = x.getBooleanElement(doc, "./ns:AccessoryDwellingUnitLegallyRentableIndicator");
		this.accessoryDwellingUnitTypicalToMarketIndicator = x.getBooleanElement(doc, "./ns:AccessoryDwellingUnitTypicalToMarketIndicator");
		this.accessType = x.getStringElement(doc, "./ns:AccessType");
		this.allowableLiveWorkSpaceIndicator = x.getBooleanElement(doc, "./ns:AllowableLiveWorkSpaceIndicator");
		this.bedroomCount = x.getIntegerElement(doc, "./ns:BedroomCount");
		this.cornerUnitIndicator = x.getBooleanElement(doc, "./ns:CornerUnitIndicator");
		this.floorIdentifier = x.getStringElement(doc, "./ns:FloorIdentifier");
		this.fullBathroomCount = x.getIntegerElement(doc, "./ns:FullBathroomCount");
		this.gradeLevelType = x.getStringElement(doc, "./ns:GradeLevelType");
		this.halfBathroomCount = x.getIntegerElement(doc, "./ns:HalfBathroomCount");
		this.interiorConditionRatingCode = x.getStringElement(doc, "./ns:InteriorConditionRatingCode");
		this.interiorQualityRatingCode = x.getStringElement(doc, "./ns:InteriorQualityRatingCode");
		this.levelCount = x.getIntegerElement(doc, "./ns:LevelCount");
		this.overallBathroomsQualityDescription = x.getStringElement(doc, "./ns:OverallBathroomsQualityDescription");
		this.overallBathroomsUpdateStatusType = x.getStringElement(doc, "./ns:OverallBathroomsUpdateStatusType");
		this.separatePostalAddressIndicator = x.getBooleanElement(doc, "./ns:SeparatePostalAddressIndicator");
		this.unitBelowGradeFinishComparisonType = x.getStringElement(doc, "./ns:UnitBelowGradeFinishComparisonType");
		this.unitIdentifier = x.getStringElement(doc, "./ns:UnitIdentifier");
		this.unitIncludedInRentScheduleIndicator = x.getBooleanElement(doc, "./ns:UnitIncludedInRentScheduleIndicator");
		this.unitInteriorDefectsExistIndicator = x.getBooleanElement(doc, "./ns:UnitInteriorDefectsExistIndicator");
		this.unitMixedUsageIndicator = x.getBooleanElement(doc, "./ns:UnitMixedUsageIndicator");
		this.unitOccupancyType = x.getStringElement(doc, "./ns:UnitOccupancyType");
		this.unitUtilitiesOperatingIndicator = x.getBooleanElement(doc, "./ns:UnitUtilitiesOperatingIndicator");
		this.unitValuationCommentText = x.getStringElement(doc, "./ns:UnitValuationCommentText");
		this.utilitiesMeteredSeparatelyIndicator = x.getBooleanElement(doc, "./ns:UtilitiesMeteredSeparatelyIndicator");
   }
}

export class RoomDetail {
    constructor(doc)
    {
		this.label = null;
		this.levelType = null;
		this.roomConditionAdditionalDescription = null;
		this.roomConditionStatusType = null;
		this.roomQualityDescription = null;
		this.roomQualitySummaryDescription = null;
		this.roomType = null;
		this.roomTypeOtherDescription = null;
		this.roomUpdatedTimeframeType = null;
		this.roomUpdateStatusType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.levelType = x.getStringElement(doc, "./ns:LevelType");
		this.roomConditionAdditionalDescription = x.getStringElement(doc, "./ns:RoomConditionAdditionalDescription");
		this.roomConditionStatusType = x.getStringElement(doc, "./ns:RoomConditionStatusType");
		this.roomQualityDescription = x.getStringElement(doc, "./ns:RoomQualityDescription");
		this.roomQualitySummaryDescription = x.getStringElement(doc, "./ns:RoomQualitySummaryDescription");
		this.roomType = x.getStringElement(doc, "./ns:RoomType");
		this.roomTypeOtherDescription = x.getStringElement(doc, "./ns:RoomTypeOtherDescription");
		this.roomUpdatedTimeframeType = x.getStringElement(doc, "./ns:RoomUpdatedTimeframeType");
		this.roomUpdateStatusType = x.getStringElement(doc, "./ns:RoomUpdateStatusType");
   }
}

export class Room {
    constructor(doc)
    {
		this.label = null;
		this.images = [];
		this.roomDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:ROOM_DETAIL");
		if (node !== null)
				this.roomDetail = new RoomDetail(node);
   }

	 GetRoomType() {
		return h.descriptionOrOther(this.roomDetail.roomType, this.roomDetail.roomTypeOtherDescription);
	 }

	GetRoomTypeLevel() {
		var lt = h.descriptionOrOther(this.roomDetail.roomType, this.roomDetail.roomTypeOtherDescription);
		lt += "\n";
		lt += h.toEnumText(this.roomDetail.levelType);
	return lt;
	}

	GetRoomLevel() {
		return h.toEnumText(this.roomDetail.levelType);
	}
}

export class UnitRentSchedule {
    constructor(doc)
    {
		this.label = null;
		this.actualRentPerUnitFinishedAreaAmount = null;
		this.financialRentalConcessionIndicator = null;
		this.leaseStartDate = null;
		this.monthToMonthLeaseIndicator = null;
		this.rentControlStatusType = null;
		this.unitChargesIncludeUtilitiesIndicator = null;
		this.unitFurnishedIndicator = null;
		this.unitMonthlyActualRentAmount = null;
		this.unitMonthlyMarketRentAmount = null;
		this.unitRentedIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.actualRentPerUnitFinishedAreaAmount  = x.getMISMOAmountElement(doc, "./ns:ActualRentPerUnitFinishedAreaAmount");
		this.financialRentalConcessionIndicator = x.getBooleanElement(doc, "./ns:FinancialRentalConcessionIndicator");
		this.leaseStartDate = x.getMISMODateElement(doc, "./ns:LeaseStartDate");
		this.monthToMonthLeaseIndicator = x.getBooleanElement(doc, "./ns:MonthToMonthLeaseIndicator");
		this.rentControlStatusType = x.getStringElement(doc, "./ns:RentControlStatusType");
		this.unitChargesIncludeUtilitiesIndicator = x.getBooleanElement(doc, "./ns:UnitChargesIncludeUtilitiesIndicator");
		this.unitFurnishedIndicator = x.getBooleanElement(doc, "./ns:UnitFurnishedIndicator");
		this.unitMonthlyActualRentAmount  = x.getMISMOAmountElement(doc, "./ns:UnitMonthlyActualRentAmount");
		this.unitMonthlyMarketRentAmount  = x.getMISMOAmountElement(doc, "./ns:UnitMonthlyMarketRentAmount");
		this.unitRentedIndicator = x.getBooleanElement(doc, "./ns:UnitRentedIndicator");
   }
}

export class UnitView {
    constructor(doc)
    {
		this.label = null;
		this.viewType = null;
		this.viewTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.viewType = x.getStringElement(doc, "./ns:ViewType");
		this.viewTypeOtherDescription = x.getStringElement(doc, "./ns:ViewTypeOtherDescription");
   }
}

export class PropertyUnit {
    constructor(doc, parentProperty, parentImprovement)
    {
		this.label = null;
		this.parentProperty = parentProperty;
		this.parentImprovement = parentImprovement;
		this.accessibilityFeatures = [];
		this.interiorComponents = [];
		this.levels = [];
		this.propertyUnitArea = null;
		this.propertyUnitDetail = null;
		this.rentalInformations = [];
		this.rooms = [];
		this.unitRentSchedule = null;
		this.unitViews = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:ACCESSIBILITY_FEATURES/ns:ACCESSIBILITY_FEATURE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.accessibilityFeatures.push(new AccessibilityFeature(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:INTERIOR_COMPONENTS/ns:INTERIOR_COMPONENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.interiorComponents.push(new InteriorComponent(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:LEVELS/ns:LEVEL");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.levels.push(new Level(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:PROPERTY_UNIT_AREA");
		if (node !== null)
				this.propertyUnitArea = new PropertyUnitArea(node);
		node = x.selectSingleNode(doc, "./ns:PROPERTY_UNIT_DETAIL");
		if (node !== null)
				this.propertyUnitDetail = new PropertyUnitDetail(node);
		nodes = x.selectNodes(doc, "./ns:RENTAL_INFORMATIONS/ns:RENTAL_INFORMATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.rentalInformations.push(new RentalInformation(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:ROOMS/ns:ROOM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.rooms.push(new Room(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:UNIT_RENT_SCHEDULE");
		if (node !== null)
				this.unitRentSchedule = new UnitRentSchedule(node);
		nodes = x.selectNodes(doc, "./ns:UNIT_VIEWS/ns:UNIT_VIEW");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.unitViews.push(new UnitView(xn));
			});
		}
   }

	IsADU() {
		return this.propertyUnitDetail.accessoryDwellingUnitIndicator ?? false;
	}

	GetLevelCount() {
		let lc = this.propertyUnitDetail.levelCount;
		if (!lc || lc === "0" || lc === 0) return "";
		return this.propertyUnitDetail.levelCount.toString();
	}

	GetBathrooms() {
			let baths = this.propertyUnitDetail.fullBathroomCount.toString();
			baths = h.addWithSpacer(baths, this.propertyUnitDetail.halfBathroomCount.toString());
			return baths;
	}

	GetRoomImages() {
			let tag = '';
			const images = [];
			for (const room of this.rooms) {
					tag = room.GetRoomLevel();
					let type = room.GetRoomType();
					tag = h.addWithSpacer(tag, type, ' - ');
					if (room.images) {
							for (const image of room.images) {
								tag = h.addWithSpacer(tag, image.imageCaptionCommentDescription, ' - ');
								image.imageSourceCaption = tag;
								images.push(image);
							}
					}
			}
			return images;
	}

	GetRoomQuality(type) {
			if (!this.rooms) return '';
			for (const room of this.rooms) {
					if (room.roomDetail.roomType === type) {
							return room.roomDetail.roomQualitySummaryDescription;
					}
			}
			return '';
	}

	GetRoomCondition(type) {
			if (!this.rooms) return '';
			for (const room of this.rooms) {
					if (room.roomDetail.roomType === type) {
							return h.toEnumText(room.roomDetail.roomUpdateStatusType);
					}
			}
			return '';
	}

	GetComponentQuality(type) {
			if (!this.interiorComponents) return '';
			for (const component of this.interiorComponents) {
					if (component.interiorComponentDetail.improvementComponentType === type) {
							return component.interiorComponentDetail.improvementComponentQualitySummaryDescription;
					}
			}
			return '';
	}

	GetComponentCondition(type) {
			if (!this.interiorComponents) return '';
			for (const component of this.interiorComponents) {
					if (component.interiorComponentDetail.improvementComponentType === type) {
							if (type === 'Flooring') {
									return h.toEnumText(component.interiorComponentDetail.overallFlooringUpdateStatusType);
							} else {
									return component.interiorComponentDetail.improvementComponentConditionSummaryDescription;
							}
					}
			}
			return '';
	}

	GetComponent(type) {
			if (!this.interiorComponents) return null;
			for (const component of this.interiorComponents) {
					if (component.interiorComponentDetail.improvementComponentType === type) {
							return component;
					}
			}
			return null;
	}

	GetOtherComponents() {
			if (!this.interiorComponents) return null;
			const list = [];
			for (const component of this.interiorComponents) {
					if (component.interiorComponentDetail.improvementComponentType === 'Other') {
							list.push(component);
					}
			}
			return list;
	}

	GetAccessibilityFeaturesList() {
			if (!this.accessibilityFeatures) return null;
			const list = [];
			for (const af of this.accessibilityFeatures) {
					if (af.accessibilityFeatureType !== 'None') {
							list.push(af);
					}
			}
			return list;
	}

	GetAccessibilityFeatures() {
			if (!this.accessibilityFeatures) return null;
			let list = '';
			for (const af of this.accessibilityFeatures) {
					if (af.accessibilityFeatureType !== 'None') {
							list = h.addWithSpacer(list, af.GetAccessibilityFeatureType());
					}
			}
			return list;
	}

	GetRoomSummary(levelType) {
			let summary = '';
			const roomCounts = {};
			for (const r of this.rooms) {
					if (r.roomDetail.levelType === levelType) {
							const type = r.GetRoomType();
							roomCounts[type] = (roomCounts[type] || 0) + 1;
					}
			}
			const sorted = Object.entries(roomCounts).sort((a, b) => a[0].localeCompare(b[0]));
			for (const [key, value] of sorted) {
					const count = `${value} - ${key}`;
					summary = h.addWithNewline(summary, count);
			}
			return summary;
	}

	GetLevelAccessType(levelType, accessType) {
			for (const l of this.levels) {
					if (l.levelType === levelType && l.accessType === accessType) {
							return l;
					}
			}
			return null;
	}

	GetSiteInfluencesComparisonType() {
			let comp = '';
			for (const rental of this.rentalInformations) {
					comp = h.addWithSpacer(comp, rental.rentalComparison.rentalComparisonDetail.siteInfluencesComparisonType);
			}
			return comp;
	}

	GetViewsComparisonType() {
			let comp = '';
			for (const rental of this.rentalInformations) {
					comp = h.addWithSpacer(comp, rental.rentalComparison.rentalComparisonDetail.viewsComparisonType);
			}
			return comp;
	}

	GetADULocation() {
		if (this.propertyUnitDetail.accessoryDwellingUnitIndicator ?? false) {
			let imp = this.parentImprovement;
			let impDetail = imp.improvementDetail;
				if (impDetail.improvementType === "Dwelling") {
						return "Dwelling";
				} else if (impDetail.improvementType === "Outbuilding") {
						if (impDetail.outbuildingRealPropertyIndicator ?? false) {
								return imp.GetOutbuildingType();
						}
				}
		}
		return "Unknown";
}

}

